import headerTop from  './header.vue'
import headerBottom from './headerBottom'
import service from './service'
import membersHeader from './membersHeader'


const h={
   install:function(vue){
       vue.component('myHeaderTop',headerTop),
       vue.component('myHeaderBottom',headerBottom),
       vue.component('myService',service),
       vue.component('myMembersHeader',membersHeader)
   }
}
export default h


// WEBPACK FOOTER //
// ./src/components/GlobalComponents/index.js